import { z } from "zod";

/**
 * StockNodeSchema - Content Schema for Stock Entity Node
 *
 * Stock nodes represent stock ticker symbols with optional sentiment analysis.
 *
 * Field naming convention:
 * - symbol: Stock ticker symbol (e.g., "AAPL", "TSLA")
 * - sentiment: Market sentiment (bullish/bearish/neutral)
 * - confidence: Confidence score (0-100, normalized from current 0-1 range)
 */
export const StockNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("stock"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  symbol: z.string().min(1).max(20),
  sentiment: z.enum(["bullish", "bearish", "neutral"]),
  confidence: z.number().min(0).max(100).nullable().optional(),
}).strict();

export type StockNode = z.infer<typeof StockNodeSchema>;
